module.exports = __webpack_public_path__ + "static/media/transaction.9fc1a962.svg";